import { PayloadAction } from 'typesafe-actions';
import { AccountExtraitTransactionDetailsProviderState, AccountExtraitTransactionDetailsActionTypes } from './types';

const AccountExtraitTransactionDetailsReducer = (
  state: AccountExtraitTransactionDetailsProviderState,
  action: PayloadAction<AccountExtraitTransactionDetailsActionTypes, any>,
): AccountExtraitTransactionDetailsProviderState => {
  switch (action.type) {
    case AccountExtraitTransactionDetailsActionTypes.setSelectedAccountExtraitTransaction:
      return {
        ...state,
        selectedAccountExtraitTransaction: action.payload,
      };
    default: {
      return state;
    }
  }
};

export { AccountExtraitTransactionDetailsReducer };
